document.documentElement.classList.remove('no-js');

/* ============================================================
   Utilities
   ============================================================ */
const GM = window.GM || {};
GM.formatMoney = function (cents, format) {
  if (typeof cents === 'string') cents = cents.replace('.', '');
  const value = (cents / 100).toFixed(2);
  const parts = value.split('.');
  const withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const money = withCommas + '.' + parts[1];
  return (format || window.themeMoneyFormat || 'Rs. {{amount}}').replace('{{amount}}', money);
};

GM.toast = function (message) {
  const el = document.getElementById('wishlist-toast');
  if (!el) return;
  el.textContent = message;
  el.classList.add('is-visible');
  clearTimeout(GM._toastTimer);
  GM._toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2400);
};

GM.trapFocus = function (container) {
  const focusables = container.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
  if (!focusables.length) return;
  focusables[0].focus();
};

/* Reusable free-shipping progress bar initializer — called on load and after any AJAX cart refresh */
GM.initShippingBar = function (scope) {
  const root = scope || document;
  root.querySelectorAll('[data-free-shipping-bar]').forEach(bar => {
    const threshold = parseFloat(bar.dataset.threshold || '0') * 100;
    const cartTotal = parseFloat(bar.dataset.cartTotal || '0');
    const fill = bar.querySelector('[data-free-shipping-fill]');
    const label = bar.querySelector('[data-free-shipping-label]');
    const pct = threshold > 0 ? Math.min(100, (cartTotal / threshold) * 100) : 100;
    if (fill) fill.style.width = pct + '%';
    if (label) {
      const remaining = Math.max(0, threshold - cartTotal);
      label.textContent = remaining > 0
        ? `🚚 You're only ${GM.formatMoney(remaining)} away from FREE Delivery!`
        : `🎉 Congratulations! You've unlocked FREE Delivery.`;
    }
  });
};

/* Local-only quantity stepper (PDP, quick view) — always +1/-1, min 1,
   no cart network call. Cart-line quantity changes (drawer/cart page)
   have their own dedicated handlers since those also need to update
   the cart via AJAX. */
GM.initQtySelectors = function (scope) {
  const root = scope || document;
  root.querySelectorAll('[data-qty-wrap]').forEach(wrap => {
    wrap.addEventListener('click', (e) => {
      const input = wrap.querySelector('input');
      if (!input) return;
      if (e.target.closest('[data-qty-plus]')) input.value = (parseInt(input.value, 10) || 1) + 1;
      if (e.target.closest('[data-qty-minus]')) input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
    });
  });
};

/* ============================================================
   Fade-in on scroll
   ============================================================ */
(function initFadeIn() {
  const els = document.querySelectorAll('.fade-in');
  if (!('IntersectionObserver' in window) || !els.length) {
    els.forEach(el => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1, rootMargin: '0px 0px -60px 0px' });
  els.forEach(el => io.observe(el));
})();

/* ============================================================
   Button ripple
   ============================================================ */
document.addEventListener('click', (e) => {
  const btn = e.target.closest('.btn--primary, .btn--dark');
  if (!btn) return;
  const ripple = document.createElement('span');
  ripple.className = 'btn__ripple';
  const rect = btn.getBoundingClientRect();
  const size = Math.max(rect.width, rect.height);
  ripple.style.width = ripple.style.height = size + 'px';
  ripple.style.left = (e.clientX - rect.left - size / 2) + 'px';
  ripple.style.top = (e.clientY - rect.top - size / 2) + 'px';
  btn.style.position = btn.style.position || 'relative';
  btn.appendChild(ripple);
  setTimeout(() => ripple.remove(), 650);
});

/* ============================================================
   Mobile nav
   ============================================================ */
(function initMobileNav() {
  const toggle = document.querySelector('[data-mobile-nav-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');
  const overlay = document.querySelector('[data-mobile-nav-overlay]');
  const close = document.querySelector('[data-mobile-nav-close]');
  if (!toggle || !nav) return;
  const open = () => { nav.classList.add('is-open'); overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; toggle.setAttribute('aria-expanded', 'true'); };
  const shut = () => { nav.classList.remove('is-open'); overlay.classList.remove('is-open'); document.body.style.overflow = ''; toggle.setAttribute('aria-expanded', 'false'); };
  toggle.addEventListener('click', open);
  close && close.addEventListener('click', shut);
  overlay && overlay.addEventListener('click', shut);
})();

/* ============================================================
   Search drawer
   ============================================================ */
(function initSearch() {
  const toggle = document.querySelector('[data-search-toggle]');
  const drawer = document.querySelector('[data-search-drawer]');
  const overlay = document.querySelector('[data-search-overlay]');
  const closeBtn = document.querySelector('[data-search-close]');
  const input = document.querySelector('[data-search-input]');
  const results = document.querySelector('[data-search-results]');
  if (!toggle || !drawer) return;

  const open = () => {
    drawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    toggle.setAttribute('aria-expanded', 'true');
    setTimeout(() => input && input.focus(), 250);
  };
  const shut = () => {
    drawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    toggle.setAttribute('aria-expanded', 'false');
  };
  toggle.addEventListener('click', open);
  closeBtn && closeBtn.addEventListener('click', shut);
  overlay && overlay.addEventListener('click', shut);
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') shut(); });

  let debounceTimer;
  input && input.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    const q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; results.classList.remove('is-visible'); return; }
    debounceTimer = setTimeout(() => {
      fetch(`${window.Shopify.routes.root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=8&resources[options][fields]=title,vendor,product_type`)
        .then(r => r.json())
        .then(data => {
          const products = data.resources.results.products || [];
          if (!products.length) { results.innerHTML = '<p class="text-center" style="grid-column:1/-1;color:var(--color-text-muted)">No products found.</p>'; }
          else {
            results.innerHTML = products.map(p => `
              <a href="${p.url}" class="product-card">
                <div class="product-card__media"><img src="${p.featured_image ? p.featured_image.url : ''}" alt="${p.title}" loading="lazy"></div>
                <div class="product-card__body">
                  <div class="product-card__title">${p.title}</div>
                  <div class="price">${GM.formatMoney(p.price)}</div>
                </div>
              </a>`).join('');
          }
          results.classList.add('is-visible');
        });
    }, 300);
  });
})();

/* ============================================================
   Cart Drawer (AJAX)
   ============================================================ */
const CartDrawer = {
  el: null,
  init() {
    this.el = document.querySelector('[data-cart-drawer]');
    this.overlay = document.querySelector('[data-cart-overlay]');
    this.toggles = document.querySelectorAll('[data-cart-toggle]');
    if (!this.el) return;
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-cart-toggle]')) { e.preventDefault(); this.open(); }
      if (e.target.closest('[data-cart-close]')) this.close();
      if (e.target.closest('[data-cart-overlay]')) this.close();
      const removeBtn = e.target.closest('[data-cart-remove]');
      if (removeBtn) { e.preventDefault(); this.updateLine(removeBtn.dataset.cartRemove, 0); }
      const plus = e.target.closest('[data-qty-plus]');
      const minus = e.target.closest('[data-qty-minus]');
      if (plus || minus) {
        const wrap = (plus || minus).closest('[data-qty-wrap]');
        /* Only real cart lines carry a key in data-qty-wrap (e.g. data-qty-wrap="{{ item.key }}").
           The PDP and quick-view use a bare data-qty-wrap for local-only stepping (GM.initQtySelectors) —
           skip those here so this global listener doesn't double-fire alongside them. */
        if (!wrap || !wrap.dataset.qtyWrap) return;
        const input = wrap.querySelector('input');
        let val = parseInt(input.value, 10) || 1;
        val = plus ? val + 1 : Math.max(0, val - 1);
        input.value = val;
        this.updateLine(wrap.dataset.qtyWrap, val);
      }
    });
    document.addEventListener('submit', (e) => {
      const form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      e.preventDefault();
      this.addItem(form);
    });
    this.refresh();
  },
  open() {
    this.el.classList.add('is-open');
    this.overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    this.toggles.forEach(t => t.setAttribute('aria-expanded', 'true'));
  },
  close() {
    this.el.classList.remove('is-open');
    this.overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    this.toggles.forEach(t => t.setAttribute('aria-expanded', 'false'));
  },
  addItem(form) {
    const formData = new FormData(form);
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.dataset.originalText = submitBtn.textContent; submitBtn.textContent = 'Adding...'; }
    fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
      .then(r => r.json())
      .then((item) => {
        if (item.status) { GM.toast(item.description || 'Could not add to cart'); return; }
        GM.toast(item.product_title + ' added to cart');
        this.refresh(true);
      })
      .catch(() => GM.toast('Something went wrong'))
      .finally(() => { if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = submitBtn.dataset.originalText; } });
  },
  updateLine(key, quantity) {
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    }).then(r => r.json()).then(() => this.refresh());
  },
  refresh(open) {
    fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newContent = doc.querySelector('[data-cart-drawer-content]');
        const current = this.el.querySelector('[data-cart-drawer-content]');
        if (newContent && current) current.innerHTML = newContent.innerHTML;
        const count = doc.querySelector('[data-cart-count-value]');
        document.querySelectorAll('[data-cart-count]').forEach(bubble => {
          const n = count ? count.textContent.trim() : '0';
          bubble.textContent = n;
          bubble.style.display = n === '0' ? 'none' : 'flex';
        });
        GM.initShippingBar(this.el);
        if (open) this.open();
      });
  }
};
CartDrawer.init();

/* ============================================================
   Cart Page (AJAX) — separate data attributes from the drawer
   so both can coexist on /cart without double-handling clicks
   ============================================================ */
(function initCartPage() {
  const page = document.querySelector('[data-cart-page-content]');
  if (!page) return;

  function refresh() {
    fetch(window.Shopify.routes.root + '?section_id=main-cart')
      .then(r => r.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-page-content]');
        const current = document.querySelector('[data-cart-page-content]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        const count = doc.querySelector('[data-cart-count-value]');
        document.querySelectorAll('[data-cart-count]').forEach(bubble => {
          const n = count ? count.textContent.trim() : '0';
          bubble.textContent = n;
          bubble.style.display = n === '0' ? 'none' : 'flex';
        });
        GM.initShippingBar(document.querySelector('[data-cart-page-content]') || document);
      });
  }

  function updateLine(key, quantity) {
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    }).then(r => r.json()).then(refresh);
  }

  document.addEventListener('click', (e) => {
    const removeBtn = e.target.closest('[data-page-cart-remove]');
    if (removeBtn) { e.preventDefault(); updateLine(removeBtn.dataset.pageCartRemove, 0); return; }
    const plus = e.target.closest('[data-page-qty-plus]');
    const minus = e.target.closest('[data-page-qty-minus]');
    if (plus || minus) {
      const wrap = (plus || minus).closest('[data-page-qty-wrap]');
      const input = wrap.querySelector('input');
      let val = parseInt(input.value, 10) || 1;
      val = plus ? val + 1 : Math.max(0, val - 1);
      input.value = val;
      updateLine(wrap.dataset.pageQtyWrap, val);
    }
  });
})();

/* ============================================================
   Wishlist (localStorage-backed)
   ============================================================ */
const Wishlist = {
  key: 'gadgetmint_wishlist',
  get() { try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; } },
  set(list) { localStorage.setItem(this.key, JSON.stringify(list)); this.updateCount(); },
  toggle(id) {
    let list = this.get();
    if (list.includes(id)) list = list.filter(i => i !== id); else list.push(id);
    this.set(list);
    return list.includes(id);
  },
  has(id) { return this.get().includes(id); },
  updateCount() {
    document.querySelectorAll('[data-wishlist-count]').forEach(el => {
      const n = this.get().length;
      el.textContent = n;
      el.style.display = n === 0 ? 'none' : 'flex';
    });
  },
  paintButtons() {
    document.querySelectorAll('[data-wishlist-toggle]').forEach(btn => {
      btn.classList.toggle('is-active', this.has(btn.dataset.wishlistToggle));
    });
  },
  init() {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-wishlist-toggle]');
      if (!btn) return;
      e.preventDefault();
      const active = this.toggle(btn.dataset.wishlistToggle);
      btn.classList.toggle('is-active', active);
      GM.toast(active ? 'Added to wishlist' : 'Removed from wishlist');
    });
    this.updateCount();
    this.paintButtons();
  }
};
Wishlist.init();

/* ============================================================
   Quick View Modal
   ============================================================ */
(function initQuickView() {
  const overlay = document.querySelector('[data-quick-view-overlay]');
  if (!overlay) return;
  const body = overlay.querySelector('[data-quick-view-body]');
  const closeShow = () => { overlay.classList.add('is-open'); document.body.style.overflow = 'hidden'; };
  const shut = () => { overlay.classList.remove('is-open'); document.body.style.overflow = ''; body.innerHTML = ''; };

  document.addEventListener('click', (e) => {
    const trigger = e.target.closest('[data-quick-view]');
    if (trigger) {
      e.preventDefault();
      body.innerHTML = '<div class="skeleton" style="height:400px;"></div>';
      closeShow();
      fetch(`${trigger.dataset.quickView}?section_id=quick-view`)
        .then(r => r.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          const content = doc.querySelector('[data-quick-view-content]');
          body.innerHTML = content ? content.innerHTML : '<p>Unable to load product.</p>';
          GM.initQtySelectors(body);
        });
    }
    if (e.target.closest('[data-quick-view-close]') || e.target === overlay) shut();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') shut(); });
})();

/* ============================================================
   Product page: gallery, variants, tabs, countdown
   ============================================================ */
(function initProductPage() {
  const root = document.querySelector('[data-product-root]');
  if (!root) return;

  /* Gallery */
  const mainImg = root.querySelector('[data-gallery-main] img');
  const galleryThumbs = root.querySelectorAll('[data-gallery-thumb]');
  galleryThumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      galleryThumbs.forEach(t => t.classList.remove('is-active'));
      thumb.classList.add('is-active');
      if (mainImg) mainImg.src = thumb.dataset.fullSrc;
    });
  });
  const mainMedia = root.querySelector('[data-gallery-main]');
  if (mainMedia && mainImg) {
    /* Cache the rect once per hover session (on enter) instead of forcing
       a layout read on every mousemove — the box doesn't move/resize
       while the cursor is over it, so one measurement is enough. */
    let mainMediaRect = null;
    mainMedia.addEventListener('mouseenter', () => {
      mainMediaRect = mainMedia.getBoundingClientRect();
    }, { passive: true });
    mainMedia.addEventListener('mousemove', (e) => {
      const rect = mainMediaRect || mainMedia.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
      mainImg.style.transformOrigin = `${x}% ${y}%`;
      mainImg.style.transform = 'scale(1.6)';
    }, { passive: true });
    mainMedia.addEventListener('mouseleave', () => {
      mainImg.style.transform = 'scale(1)';
      mainMediaRect = null;
    }, { passive: true });
  }

  /* Tabs */
  const tabButtons = root.querySelectorAll('[data-tab-btn]');
  const tabPanels = root.querySelectorAll('[data-tab-panel]');
  tabButtons.forEach(btn => {
    btn.addEventListener('click', () => {
      tabButtons.forEach(b => b.classList.remove('is-active'));
      tabPanels.forEach(p => p.classList.remove('is-active'));
      btn.classList.add('is-active');
      root.querySelector(`[data-tab-panel="${btn.dataset.tabBtn}"]`).classList.add('is-active');
    });
  });

  /* Quantity selector on PDP */
  GM.initQtySelectors(root);
})();

/* ============================================================
   Countdown timers (flash sale)
   ============================================================ */
document.querySelectorAll('[data-countdown]').forEach(el => {
  const end = new Date(el.dataset.countdown).getTime();
  const dEl = el.querySelector('[data-cd-days]');
  const hEl = el.querySelector('[data-cd-hours]');
  const mEl = el.querySelector('[data-cd-mins]');
  const sEl = el.querySelector('[data-cd-secs]');
  function tick() {
    const diff = Math.max(0, end - Date.now());
    const d = Math.floor(diff / 86400000);
    const h = Math.floor((diff % 86400000) / 3600000);
    const m = Math.floor((diff % 3600000) / 60000);
    const s = Math.floor((diff % 60000) / 1000);
    if (dEl) dEl.textContent = String(d).padStart(2, '0');
    if (hEl) hEl.textContent = String(h).padStart(2, '0');
    if (mEl) mEl.textContent = String(m).padStart(2, '0');
    if (sEl) sEl.textContent = String(s).padStart(2, '0');
    if (diff > 0) requestAnimationFrame(() => setTimeout(tick, 1000));
  }
  tick();
});

/* ============================================================
   Accordion (FAQ) — event-delegated so it keeps working even if
   Shopify's Theme Editor hot-swaps the section's HTML on setting changes
   ============================================================ */
document.addEventListener('click', (e) => {
  const trigger = e.target.closest('[data-accordion-trigger]');
  if (!trigger) return;
  const item = trigger.closest('[data-accordion-item]');
  if (!item) return;
  const group = item.closest('[data-accordion]');
  if (!group) return;
  const panel = item.querySelector('[data-accordion-panel]');
  if (!panel) return;
  const isOpen = item.classList.contains('is-open');
  group.querySelectorAll('[data-accordion-item]').forEach(i => {
    i.classList.remove('is-open');
    const p = i.querySelector('[data-accordion-panel]');
    if (p) p.style.maxHeight = null;
    const t = i.querySelector('[data-accordion-trigger]');
    if (t) t.setAttribute('aria-expanded', 'false');
  });
  if (!isOpen) {
    item.classList.add('is-open');
    panel.style.maxHeight = panel.scrollHeight + 'px';
    trigger.setAttribute('aria-expanded', 'true');
  }
});

/* ============================================================
   Free shipping progress bar — initial render
   ============================================================ */
GM.initShippingBar();
